const brightenergy = {
  100: "#FEFDF1",
  200: "#FCFBE3",
  300: "#F9F7C7",
  400: "#F6F4AC",
  500: "#F3F090",
  600: "#F0EC74",
  700: "#C0BD5D",
  800: "#908E46",
  900: "#605E2E",
  contrastDefaultColor: "#ffffff"
}

export default brightenergy
